import React, { useEffect, useCallback } from 'react'
import { hooks } from '@front/volcanion'
import HookUtils from '@front/volcanion/utils/hooks'

import moment from 'moment'

const withContainer = Component => props => {
  const [, { openDialog }] = hooks.useDialogs()

  const [service] = hooks.useFieldValues(['service'])
  const isSubmitting = hooks.useFormStatus('isSubmitting')
  const requestSubmit = hooks.useFormFunction('requestSubmit')

  const [{ addressrepository_id, commercial_package }] = hooks.useFormState()

  const [, setCommercialPackage] = hooks.useFormState('commercial_package')

  const [[ridemode], , ridemode_status] = hooks.useModelSearch('ridemode', 'get', { initial_filter: {}, sort: ['display_index ASC'] })
  const [packages] = hooks.useEstimation({
    source_details: { addressrepository_id },
    destination_details: null,
    load_type: 'user',
    service,
    requestedAt: moment.utc().format(),
    mode: ridemode?.ridemode_id

  }, { isReady: !!addressrepository_id && !!service && !!ridemode?.ridemode_id })
  const isLoadingRidemode = HookUtils.getLoadingState([ridemode_status])

  const getPaymentTypeFilter = useCallback(() => ({ service_id: service, load_type: 'user' }), [service])

  const cp_ids = _.sortBy(_.map(packages, 'commercial_package_id'), 'display_index')
  const first_package = _.head(cp_ids)

  const openPackageFormPopup = useCallback(() => openDialog('package_form', { allowVehicleCount: true, enableFooter: false }), [openDialog])

  const onSubmit = useCallback(() => requestSubmit({ ridemode: ridemode?.ridemode_id }), [isLoadingRidemode])

  useEffect(() => {
    setCommercialPackage(first_package)
  }, [first_package])


  const mergedProps = {
    isSubmitting,
    onSubmit,
    commercial_package,
    service,
    getPaymentTypeFilter,
    openPackageFormPopup
  }

  return (
    <Component {...mergedProps} {...props} />
  )
}
export default withContainer